import React from 'react';
import { Modal } from 'antd';
import { useSubscriptionsPageController } from '../controllers/useSubscriptionsPageController';
import OrderNumberModal from '../../../components/numbers/modals/order-number/OrderNumberModal';
import AssignNumberModal from '../../../components/numbers/modals/assign-number/AssignNumberModal';
import CancelNumberModal from '../../../components/numbers/modals/cancel-number/CancelNumberModal';
import ChangeSubscriptionModal from '../../../components/numbers/modals/change-subscription/ChangeSubscriptionModal';
import SubscriptionConsumptionHistory from '../../../components/@shared/consumption-history/SubscriptionConsumptionHistory';

interface SubscriptionsPageModalsProps {
  state: ReturnType<typeof useSubscriptionsPageController>['state'];
  actions: ReturnType<typeof useSubscriptionsPageController>['actions'];
}

export const SubscriptionsPageModals: React.FC<SubscriptionsPageModalsProps> = ({ state, actions }) => {
  const { activeModal, selectedSubscription, userOptions } = state;
  const {
    closeModal,
    handleConfirmOrder,
    handleAssignSubscription,
    answerContactsTransfer,
    handleCancelNumber,
    handleChangeSubscription,
  } = actions;

  return (
    <>
      <OrderNumberModal
        isOpen={activeModal === 'ORDER_NUMBER'}
        isLoading={state.isOrderLoading}
        onCancel={closeModal}
        onConfirm={handleConfirmOrder}
      />
      <AssignNumberModal
        isOpen={activeModal === 'ASSIGN_NUMBER'}
        isLoading={state.isAssignLoading}
        subscription={selectedSubscription}
        users={userOptions}
        transferQuestion={state.transferQuestion}
        isAssigning={state.isAssigning}
        onCancel={closeModal}
        onConfirm={handleAssignSubscription}
        onAnswerTransfer={answerContactsTransfer}
      />
      <CancelNumberModal
        isOpen={activeModal === 'CANCEL_NUMBER'}
        subscription={selectedSubscription}
        isLoading={state.isCancelLoading}
        onCancel={closeModal}
        onConfirm={handleCancelNumber}
      />
      <ChangeSubscriptionModal
        isOpen={activeModal === 'CHANGE_SUBSCRIPTION'}
        isLoading={state.isChangePlanLoading}
        subscription={selectedSubscription}
        onCancel={closeModal}
        onConfirm={handleChangeSubscription}
      />
      <Modal
        open={activeModal === 'CONSUMPTION_HISTORY'}
        onCancel={closeModal}
        footer={null}
        centered
        width={650}
        title={selectedSubscription?.sender_formatted || 'Historique de consommation'}
      >
        <SubscriptionConsumptionHistory
          open={activeModal === 'CONSUMPTION_HISTORY'}
          idSubscription={selectedSubscription?.id}
        />
      </Modal>
    </>
  );
};
